import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const links: Record<string, string> = {
  result: '/infoTrac/reverse-mail-tracking/details',
};

const path = '../oldPages/reverseMail/search-result/index.html';

function ReverseMailSearchResult() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const result = iframeDocument.getElementsByClassName('resultDetails');

      if (result.length) {
        for (let i = 0; i < result.length; i++) {
          const name = result[i]?.getAttribute('data-name');

          result[i].addEventListener('click', () => navigate(`${links.result}?name=${name}`));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <iframe ref={iframeRef} title="reverseMailSearchResult" src={path} className="flex-grow border-none" />
    </div>
  );
}

export default ReverseMailSearchResult;
